import React from 'react'

const StopIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="stopGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 100, 100, 1)" />
          <stop offset="100%" stopColor="rgba(220, 60, 60, 1)" />
        </linearGradient>
        <filter id="stopGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Stop square */}
      <rect 
        x="6" 
        y="6" 
        width="12" 
        height="12" 
        rx="2"
        fill="url(#stopGradient)"
        filter="url(#stopGlow)"
      />
      
      {/* Highlight */}
      <rect 
        x="8" 
        y="8" 
        width="5" 
        height="5" 
        fill="rgba(255, 255, 255, 0.2)"
      />
    </svg>
  )
}

export default StopIcon
